import { ReactElement, useContext } from 'react'
import { ThemeProvider } from '@emotion/react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import developusTheme from '../common/theme/developus-theme'
import { CssBaseline } from '@mui/material'
import Layout from '../common/ui/layout/Layout'
import ProtectedRoute from './ProtectedRoute'
import ErrorPage from '../pages/common/ErrorPage'
import Home from '../pages/home/ui/Home'
import TheoryLessons from '../pages/lessons/ui/TheoryLessons'
import DrivingLessons from '../pages/lessons/ui/DrivingLessons'
import Calendar from '../pages/calendar/ui/Calendar'
import { Settings } from '@mui/icons-material'
import SchoolCars from '../pages/vehicles/ui/SchoolCars'
import SchoolMotorcycles from '../pages/vehicles/ui/SchoolMotorcycles'
import SchoolTrucks from '../pages/vehicles/ui/SchoolTrucks'
import StudentsPage from '../pages/users/ui/students/StudentsPage'
import KeycloakContext from '../auth/KeycloakContext'
import TestPage from '../common/ui/test/TestPage'

const AppRouter = (): ReactElement => {
  const { initialized } = useContext(KeycloakContext)
  const roles = ['administrator']

  return (
    <>
      {!initialized && <div> Loading ... </div>}
      {initialized && (
        <BrowserRouter>
          <ThemeProvider theme={developusTheme}>
            <CssBaseline enableColorScheme />
            <Layout>
              <Routes>
                <Route path="/" element={<ProtectedRoute roles={roles} />}>
                  <Route path="/" element={<Home />} />
                </Route>

                <Route
                  path="/administrators"
                  element={<ProtectedRoute roles={roles} />}
                >
                  <Route path="/administrators" element={<Home />} />
                </Route>
                <Route
                  path="/teachers"
                  element={<ProtectedRoute roles={roles} />}
                >
                  <Route path="/teachers" element={<Home />} />
                </Route>
                <Route
                  path="/students"
                  element={<ProtectedRoute roles={roles} />}
                >
                  <Route path="/students" element={<StudentsPage />} />
                </Route>

                <Route
                  path="/theory-lessons"
                  element={<ProtectedRoute roles={roles} />}
                >
                  <Route path="/theory-lessons" element={<TheoryLessons />} />
                </Route>
                <Route
                  path="/driving-lessons"
                  element={<ProtectedRoute roles={roles} />}
                >
                  <Route path="/driving-lessons" element={<DrivingLessons />} />
                </Route>

                <Route
                  path="/calendar"
                  element={<ProtectedRoute roles={roles} />}
                >
                  <Route path="/calendar" element={<Calendar />} />
                </Route>

                <Route
                  path="/school-cars"
                  element={<ProtectedRoute roles={roles} />}
                >
                  <Route path="/school-cars" element={<SchoolCars />} />
                </Route>
                <Route
                  path="/school-motorcycles"
                  element={<ProtectedRoute roles={roles} />}
                >
                  <Route
                    path="/school-motorcycles"
                    element={<SchoolMotorcycles />}
                  />
                </Route>
                <Route
                  path="/school-trucks"
                  element={<ProtectedRoute roles={roles} />}
                >
                  <Route path="/school-trucks" element={<SchoolTrucks />} />
                </Route>

                <Route
                  path="/settings"
                  element={<ProtectedRoute roles={roles} />}
                >
                  <Route path="/settings" element={<Settings />} />
                </Route>

                <Route path="/test" element={<ProtectedRoute roles={roles} />}>
                  <Route path="/test" element={<TestPage />} />
                </Route>

                <Route path="/*" element={<ErrorPage />} />
              </Routes>
            </Layout>
          </ThemeProvider>
        </BrowserRouter>
      )}
    </>
  )
}

export default AppRouter
